import React from "react";
import "./Blog.css";
import blogImage from "../../images/blogimg/1.webp";
import { Link } from "react-router-dom";

const posts = [
  {
    id: 1,
    title: "Why You Should Never Ignore Your Automatic Transmission Fluid Maintenance",
    excerpt:
      "Automatic transmission fluid is the lifeblood of your gearbox. Discover why regular ATF maintenance is critical for performance, safety, and long-term savings.",
    date: "Feb 12, 2026",
    image: blogImage,
  },
];

const Blog = () => {
  return (
    <main className="section blog-page">

      <div className="container">
        <br />
        {/* Breadcrumb */}
        <nav className="app-breadcrumb">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <span className="current">Blog</span>
        </nav>
        <section className="blog-hero fade-up">
          <h1>Our Blog</h1>
          <p>
            Expert insights from Fanfaro on lubrication technology, vehicle maintenance,
            and performance engineering.
          </p>
        </section>

        {/* <section className="blog-grid">
          {posts.map((post) => (
            <Link
              to={`/blogs/${post.id}`}
              key={post.id}
              className="blog-card slide-up"
            >
              <div className="blog-card-img">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-card-content">
                <p className="blog-date">{post.date}</p>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <span className="btn btn-primary btn-blog">
                  Read Full Article
                </span>
              </div>
            </Link>
          ))}
        </section> */}


      </div>
    </main>
  );
};

export default Blog;
